import { render, staticRenderFns } from "./TradeInstrumentView.vue?vue&type=template&id=7137dac4&scoped=true"
import script from "./TradeInstrumentView.vue?vue&type=script&lang=ts"
export * from "./TradeInstrumentView.vue?vue&type=script&lang=ts"
import style0 from "./TradeInstrumentView.vue?vue&type=style&index=0&id=7137dac4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7137dac4",
  null
  
)

export default component.exports